// Small, DOM-free derivations of "which team is the player, and where did they
// finish" — the two questions the UI, the share card, and the replay verifier
// all ask repeatedly. Centralised so the answer (and its fallback) lives in one
// place instead of a `find(isPlayer) ?? opponents[0]` incantation scattered
// across four files, each an independent chance to mistake a rival for the player.
import type { SeasonState, Standings, Team } from "../types";

/**
 * The player's team in a season, or null if none is flagged. The player is
 * always present once the draft finalizes; callers that render player-specific
 * UI should treat null as "nothing to show" rather than falling back to a rival.
 */
export const playerTeam = (s: SeasonState): Team | null =>
  s.opponents.find((team) => team.isPlayer) ?? null;

/**
 * The player's 1-based Constructors' Championship position in finished
 * standings; 0 when the player isn't present (an explicit "absent" sentinel).
 */
export const playerWccPos = (st: Standings): number =>
  st.constructors.findIndex((c) => c.isPlayer) + 1;
